export default __webpack_public_path__ + "static/media/placeholder.7d1af028.jpg";